import { Upload, UploadType } from "@eave/shared/types/api";

import APIClient from "web_modules/APIClient";

export const createUpload = async (file, type: UploadType): Promise<Upload> => {
  return APIClient.dropzoneUpload("/uw/uploads", file.name, file, { upload_type: type }).then(
    ({ uploads }) => uploads[0],
  );
};

export const deleteUpload = async (id: number): Promise<boolean> => {
  return APIClient.deleteRequest(`/uw/uploads/${id}`).then(() => true);
};

export const restoreUpload = async (id: number): Promise<Upload> => {
  return APIClient.post(`/uw/uploads/${id}/restore`, {}).then(({ upload }) => upload);
};
